import React, { useState } from 'react';
import { TiPencil } from "react-icons/ti";
import { FaRegSave } from "react-icons/fa";
import { Link } from "react-router-dom"; // Added for sidebar links
import Header from '../../../../../../header/header';
import Navvbar from '../../../../../../header/Navvbar';
import Footer from '../../../../../../footer.js'; // Added import for Footer

const EditAttributePrices = () => {
  const [percentage, setPercentage] = useState('');
  const designData = [
    {
      name: "vbnn",
      classification: "",
      defaultPrice: { value: "US$10.00", highlight: true, note: "/ Inherit From Procedure" },
      group: "",
      account: "",
      procedure: "",
      specialPrice: ""
    },
    {
      name: "",
      classification: "",
      defaultPrice: { value: "", highlight: false },
      group: "default",
      account: "Zingsis s.a.",
      procedure: "1-7 ALIGNERS (DUAL ARCH)",
      specialPrice: { value: "-US$10.00", highlight: true }
    },
    {
      name: "abcd",
      classification: "",
      defaultPrice: { value: "US$12.00", highlight: true, note: "/ By Teeth" },
      group: "",
      account: "",
      procedure: "",
      specialPrice: ""
    },
    {
      name: "",
      classification: "",
      defaultPrice: "",
      group: "1",
      account: "",
      procedure: "Astra Steco EV 4-8 mm sleeve",
      specialPrice: { value: "US$10.00", highlight: true }
    },
  ];
  // New data array for Alloy / Material based on the image
  const alloyData = [
    {
      name: "Noble",
      classification: "N",
      defaultPrice: { value: "US$29.50", highlight: true, note: "/ g" },
      group: "",
      account: "",
      procedure: "",
      specialPrice: ""
    },
  ];
  // Highlight styles
  const highlightStyle = {
    border: '2px solid #f4f4f4',
    borderRadius: '4px',
    padding: '5px 8px',
    fontWeight: 'bold',
    color: '#333',
    position: 'relative'
  };
  const defaultCellStyle = {
    padding: '0 10px'
  };
  const renderPriceCell = (priceData, isDefaultPrice = false) => {
    if (!priceData) return <span style={defaultCellStyle}></span>;
   
    if (priceData.highlight) {
      return (
        <div style={{ ...highlightStyle, textAlign: isDefaultPrice ? 'center' : 'left' }}>
          {priceData.value}
          {priceData.note && (
            <div style={{ fontSize: '0.8em', color: '#6c757d', fontStyle: 'italic', marginTop: '2px' }}>
              {priceData.note}
            </div>
          )}
        </div>
      );
    }
   
    return (
      <span style={{ ...defaultCellStyle, textAlign: isDefaultPrice ? 'center' : 'left', fontWeight: 'bold' }}>
        {priceData.value}
      </span>
    );
  };
  return (
    <>
      <div style={{ marginBottom: "25px" }}>
        <Header />
        <Navvbar />
      </div>
      <div style={{ width: "95%", margin: "0 auto", padding: "0px" }}>
        <div className="row">
          <div
            className="col-md-2"
            style={{ borderRight: "1px solid #004aad" }}
          >
            <div>
              <h2 style={{ marginLeft: "10px" }}>Settings</h2>
              <div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/Tabs"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: " #004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Lab Details
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: " #004aad",
                      marginLeft: "13px",
                    }}
                  >
                    Store
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/usersetting"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: " #004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Users
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: " #004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Permission Groups
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/Account"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: " #004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Accounts
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/Owerviews"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: " #004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Finances
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/owersetting"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: " #004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Case Settings
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-10">
            <h1>Edit Attribute Prices</h1>
            <h2 style={{ color: '#004aad', marginBottom: '10px' }}>Edit Tools</h2>
            <div
              style={{
                backgroundColor: '#f0f0f0',
                padding: '10px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                borderTop: '2px solid #004aad',
                marginBottom: '20px',
                height: '90px',
              }}
            >
              <div style={{ marginBottom: '10px' }}>
                <label style={{ marginRight: '10px' }}>Alter Prices by</label>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <input type="text" style={{ marginRight: '10px' }} />
                <select
                  value={percentage}
                  onChange={(e) => setPercentage(e.target.value)}
                  style={{
                    padding: '5px',
                    marginRight: '10px',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    appearance: 'auto',
                    width: '120px'
                  }}
                >
                  <option value="">%</option>
                  <option value="0.05">% next £0.05</option>
                  <option value="0.10">% next £0.10</option>
                  <option value="1.00">% next £1.00</option>
                  <option value="">£</option>
                </select>
                <button style={{ backgroundColor: '#004aad', color: 'white', padding: '5px 10px', border: 'none', cursor: 'pointer' }}>
                  <TiPencil />Alter Prices
                </button>
              </div>
            </div>
            <h2 style={{ color: '#004aad', marginBottom: '10px' }}>Design</h2>
            <div
              style={{
                backgroundColor: '#f4f4f4',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                padding: '10px',
                borderTop: '2px solid #004aad',
                height: '60px',
                alignItems: 'center',
              }}
            >
              <span style={{ flex: 1, textAlign: 'left', padding: '0 10px', fontWeight: 'bold' }}>Name</span>
              <span style={{ flex: 1, textAlign: 'left', padding: '0 10px', fontWeight: 'bold' }}>Classification</span>
              <span style={{ flex: 1, textAlign: 'center', padding: '0 10px', fontWeight: 'bold' }}>Default Price</span>
              <span style={{ flex: 1, textAlign: 'left', padding: '0 10px', fontWeight: 'bold' }}>Group</span>
              <span style={{ flex: 1, textAlign: 'left', padding: '0 10px', fontWeight: 'bold' }}>Account</span>
              <span style={{ flex: 1, textAlign: 'left', padding: '0 10px', fontWeight: 'bold' }}>Procedure</span>
              <span style={{ flex: 1, textAlign: 'center', padding: '0 10px', fontWeight: 'bold' }}>Special Price</span>
            </div>
            {designData.map((row, index) => (
              <div
                key={index}
                style={{
                  backgroundColor: 'white',
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  padding: '10px',
                  borderBottom: '1px solid #ccc',
                  alignItems: 'center',
                  minHeight: '60px',
                }}
              >
                <span style={{ flex: 1, textAlign: 'left', padding: '0 10px' }}>{row.name}</span>
                <span style={{ flex: 1, textAlign: 'left', padding: '0 10px' }}>{row.classification}</span>
                <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
                  {renderPriceCell(row.defaultPrice, true)}
                </div>
                <span style={{ flex: 1, textAlign: 'left', padding: '0 10px' }}>{row.group}</span>
                <span style={{ flex: 1, textAlign: 'left', padding: '0 10px' }}>{row.account}</span>
                <span style={{ flex: 1, textAlign: 'left', padding: '0 10px' }}>{row.procedure}</span>
                <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
                  {renderPriceCell(row.specialPrice)}
                </div>
              </div>
            ))}
            <h2 style={{ color: '#004aad', marginBottom: '10px' }}>Alloy / Material</h2>
            <div
              style={{
                backgroundColor: '#f4f4f4',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                padding: '10px',
                borderTop: '2px solid #004aad',
                height: '60px',
                alignItems: 'center',
              }}
            >
              <span style={{ flex: 1, textAlign: 'left', padding: '0 10px', fontWeight: 'bold' }}>Name</span>
              <span style={{ flex: 1, textAlign: 'left', padding: '0 10px', fontWeight: 'bold' }}>Classification</span>
              <span style={{ flex: 1, textAlign: 'center', padding: '0 10px', fontWeight: 'bold' }}>Default Price</span>
              <span style={{ flex: 1, textAlign: 'left', padding: '0 10px', fontWeight: 'bold' }}>Group</span>
              <span style={{ flex: 1, textAlign: 'left', padding: '0 10px', fontWeight: 'bold' }}>Account</span>
              <span style={{ flex: 1, textAlign: 'left', padding: '0 10px', fontWeight: 'bold' }}>Procedure</span>
              <span style={{ flex: 1, textAlign: 'center', padding: '0 10px', fontWeight: 'bold' }}>Special Price</span>
            </div>
            {alloyData.map((row, index) => (
              <div
                key={index}
                style={{
                  backgroundColor: 'white',
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  padding: '10px',
                  borderBottom: '1px solid #ccc',
                  alignItems: 'center',
                  minHeight: '60px',
                }}
              >
                <span style={{ flex: 1, textAlign: 'left', padding: '0 10px' }}>{row.name}</span>
                <span style={{ flex: 1, textAlign: 'left', padding: '0 10px' }}>{row.classification}</span>
                <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
                  {renderPriceCell(row.defaultPrice, true)}
                </div>
                <span style={{ flex: 1, textAlign: 'left', padding: '0 10px' }}>{row.group}</span>
                <span style={{ flex: 1, textAlign: 'left', padding: '0 10px' }}>{row.account}</span>
                <span style={{ flex: 1, textAlign: 'left', padding: '0 10px' }}>{row.procedure}</span>
                <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
                  {renderPriceCell(row.specialPrice)}
                </div>
              </div>
            ))}
            <div
              style={{
                backgroundColor: '#f4f4f4',
                padding: '10px',
                display: 'flex',
                justifyContent: 'flex-end',
                borderTop: '2px solid #004aad',
              }}
            >
              <button
                style={{
                  backgroundColor: '#004aad',
                  color: 'white',
                  padding: '8px 8px',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <span style={{ marginRight: '5px' }}><FaRegSave /></span> Save
              </button>
            </div>
          </div>
        </div>
      </div>
      <div style={{ width: "95%", margin: "0 auto", padding: "0px" }}>
        <Footer />
      </div>
    </>
  );
};

export default EditAttributePrices;